export default class UserManagementFilter {
  constructor() {
    this.value = null
    this.role = null
    this.state = 'SHOW_ALL'
  }
}
